import {COPILOT_AGENT_SLUG, COPILOT_CMC_SLUG} from '@github-ui/copilot-shared-ui/agents/agent-helpers'
import {deriveSourceFromAgentSlug} from '../types/origin'

export const ENVIRONMENT_BUCKET_CLOUD = 'cloud' as const
export const ENVIRONMENT_BUCKET_ACTIONS = 'actions' as const
export const ENVIRONMENT_BUCKET_HOST = 'host' as const
export const ENVIRONMENT_BUCKET_OTHER = 'other' as const

export const SESSION_ENVIRONMENT_BUCKET_ORDER = [
  ENVIRONMENT_BUCKET_CLOUD,
  ENVIRONMENT_BUCKET_ACTIONS,
  ENVIRONMENT_BUCKET_HOST,
  ENVIRONMENT_BUCKET_OTHER,
] as const

export type SessionEnvironmentBucket = (typeof SESSION_ENVIRONMENT_BUCKET_ORDER)[number]

export const SESSION_ENVIRONMENT_BUCKET_LABELS: Record<SessionEnvironmentBucket, string> = {
  [ENVIRONMENT_BUCKET_CLOUD]: 'Cloud',
  [ENVIRONMENT_BUCKET_ACTIONS]: 'Actions',
  [ENVIRONMENT_BUCKET_HOST]: 'Host',
  [ENVIRONMENT_BUCKET_OTHER]: 'Other',
}

export function getSessionEnvironmentBucket(
  kind: string | null | undefined,
  agentSlug?: string | null,
): SessionEnvironmentBucket {
  switch (kind) {
    case 'managed-sandbox':
      return ENVIRONMENT_BUCKET_CLOUD
    case 'managed-actions':
    case 'managed-cca':
      return ENVIRONMENT_BUCKET_ACTIONS
    case 'user-local':
    case 'user-codespace':
      return ENVIRONMENT_BUCKET_HOST
  }

  // With no environment, mirror the hovercard's local-source slug derivation without its Cloud default.
  // Skip getEffectiveSource's origin.source and ADO-artifact checks because the backend does not send
  // origin.source today; revisit this if it starts to.
  if (kind) return ENVIRONMENT_BUCKET_OTHER

  if (deriveSourceFromAgentSlug(agentSlug) === 'local') return ENVIRONMENT_BUCKET_HOST
  if (agentSlug === COPILOT_CMC_SLUG || agentSlug === COPILOT_AGENT_SLUG) return ENVIRONMENT_BUCKET_ACTIONS
  return ENVIRONMENT_BUCKET_OTHER
}
